import { DispositionType, Patient } from '@doc-abode/data-models';

export function isAdminJob(job?: Patient): boolean {
    if (!job) {
        return false;
    }

    return job.disposition === DispositionType.ADMIN;
}
